/* eslint-disable camelcase */
import { call, put, takeLatest } from 'redux-saga/effects';

import { ROUTES, API } from 'utils/Apis';
import { checkStatusCodeApi } from 'utils/Helpers';

import { Types } from '../redux';

// worker Saga: will be fired on SIGN_UP_ACCOUNT actions
function* likeProductEnquiry(action) {
  try {
    /**
     * Example data
     * url: enpoint/register
     *
     */
    const response = yield call(() => API.post(ROUTES.API_LIKE, action.data));

    if (response.ok) {
      const { data } = response?.data;
      // In case: signup request success
      yield put({
        type: Types.LIKE_PRODUCT_ENQUIRY_SUCCESS,
        data,
        isLike: action?.isLike,
      });
    } else {
      const { data } = response;
      checkStatusCodeApi(data?.code || null)

      yield put({
        type: Types.LIKE_PRODUCT_ENQUIRY_FAILED,
      });
    }
  } catch (error) {
    // in case: server error
    yield put({ type: Types.LIKE_PRODUCT_ENQUIRY_FAILED, error });
  }
}

/*
  Starts likeProductEnquiry on each dispatched `LIKE_PRODUCT_ENQUIRY` action.
*/
function* likeProductEnquirySaga() {
  yield takeLatest(Types.LIKE_PRODUCT_ENQUIRY, likeProductEnquiry);
}

export default likeProductEnquirySaga;
